import * as React from 'react';
import styled from 'styled-components';

import Description from 'report/common/Description';

const Container = styled.div`
  padding-top: 30%;
  min-height: 600px;
`;

const Headline = styled.h1`
  color: black !important;
  font-size: 2em;
  text-align: center;
  margin-bottom: 0.8em;
`;

const Subheadline = styled.h2`
  color: #555 !important;
  font-size: 1.6em;
  text-align: center;
`;

type Props = {
  description: string;
  subtitle: string | undefined;
  title: string;
};

const CoverPage = ({ title, description, subtitle }: Props) => (
  <Container>
    <Headline>{title}</Headline>
    <Subheadline className="has-bm">{subtitle}</Subheadline>
    {description && <Description>{description}</Description>}
  </Container>
);

export default CoverPage;
